var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 44,
    viewBox: "0 0 56 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M55.7635 13.6863C55.7635 16.3506 55.1892 18.6661 54.0486 20.6207C52.9039 22.5835 51.2901 24.0961 49.1991 25.1666C47.112 26.2372 44.6286 26.7765 41.7731 26.7765H34.1732V14.9394L44.0907 15.0691V11.971L31.0831 11.8412V34.9397L19.2768 43.6787V11.8372H0L8.51802 0H41.7691C44.6246 0 47.1039 0.535276 49.195 1.60991C51.282 2.67643 52.8999 4.18903 54.0445 6.13553C55.1851 8.07798 55.7595 10.9856 55.7595 13.6782L55.7635 13.6863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M46.6064 39.5099C49.4943 39.1044 51.4196 37.3525 52.3458 34.6477C53.2842 34.8545 53.9151 35.1627 54.5582 35.8481C55.3267 36.6632 55.63 37.4701 55.7028 38.5934C55.715 38.7637 55.6503 38.8246 55.4966 38.8448C52.9242 39.2139 51.1324 40.7629 50.1415 43.1231C50.0336 43.3772 49.8489 43.4637 49.5873 43.3826C47.8198 42.8311 46.7723 41.5334 46.6105 39.6802C46.6064 39.6315 46.6105 39.5788 46.6105 39.5058L46.6064 39.5099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M46.6066 38.5975C46.7643 36.2292 48.9687 34.23 51.4885 34.4206C51.1649 35.3736 50.6957 36.2211 50 36.9389C49.0779 37.8959 47.9251 38.4028 46.6025 38.5975H46.6066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M55.7639 39.6843C55.5374 41.8862 53.4423 43.849 50.9185 43.6705C51.2906 42.6851 51.8164 41.8173 52.5808 41.1076C53.4706 40.2844 54.5425 39.8465 55.7639 39.6843Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.392ad12165254644a9888f41a5990969.svg";
export { ForwardRef as ReactComponent };